import { render, staticRenderFns } from "./SummonNec.vue?vue&type=template&id=021051dd"
import script from "./SummonNec.vue?vue&type=script&lang=js"
export * from "./SummonNec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports